import { Input, styled } from '@material-ui/core';

const CategorySelectInput = styled(Input)(({ theme }) => ({
  lineHeight: `${theme.spacing(4)}px`,
}));

export default CategorySelectInput;
